// About Us copy: the sales & marketing direction, with facts from the live
// xeratec.com/about-us/ page. The team roster lives in data/team.js.

export const aboutHero = {
  eyebrow: "About Xeratec · Est. 2003 · Hancock, Michigan",
  title: "Bridging construction *and technology.*",
  lede: "Construction builds everything — and the technology world has left it underserved for too long. We're a second-generation family company closing that gap with real software, built for real builders. This is our story, our mission, and the team doing the work.",
};

export const aboutStats = [
  { value: "2003", label: "founded by Steve Hillstrom" },
  { value: "2nd", label: "generation of family leadership" },
  { value: "20+", label: "years in business" },
];

export const story = {
  eyebrow: "Our story",
  title: "It started with one guy making his own job *easier.*",
  paragraphs: [
    "Before Xeratec existed, Steve Hillstrom was working warehousing and logistics at American Hospital Supply — and he taught himself programming for one simple reason: to make his own job easier. Other departments noticed. The side skill became a career, the career became a degree in MIS from DePaul University, and in 2003, it became Xeratec — all while raising more than a handful of kids at home.",
    "It started as a one-man shop: Steve building custom software for businesses he knew personally — handshake deals, word of mouth, real relationships. That shop grew into a full team, and for two decades Xeratec built custom software for whoever needed it — healthcare, manufacturing, logistics, finance. The roots never changed: listen first, understand the real problem, and build exactly what the work needs.",
    "Then, just a few years ago, came the pivot. The second generation — Jordan and Brett Hillstrom, both with backgrounds in construction — stepped into leadership and pointed twenty years of software experience at the industry they knew was being left behind by the technology world. We can still serve anyone. But construction is where the gap between the work and the tech is widest — and bridging that gap is now the mission, grounded in the same family values the company was built on: hard work, dedication, and a commitment to making a difference.",
    "And one more thing that hasn't changed: we don't build-and-bail. Xeratec works as a long-term partner — supporting, evolving, and improving the software as our customers grow.",
  ],
  timeline: [
    {
      when: "Before 2003",
      text: "Steve teaches himself to program on the warehouse floor at American Hospital Supply — to make his own job easier.",
    },
    {
      when: "2003",
      text: "Xeratec is founded in Hancock, Michigan — a one-man shop building custom software for businesses Steve knew personally.",
    },
    {
      when: "The growth years",
      text: "Custom software for whoever needed it — healthcare, manufacturing, logistics, finance.",
    },
    {
      when: "Second generation",
      text: "Jordan and Brett Hillstrom — both with backgrounds in construction — step into leadership.",
    },
    {
      when: "The pivot",
      text: "Just a few years ago, Xeratec points two decades of software experience at the underserved construction industry.",
    },
    {
      when: "Today",
      text: "We focus on construction technology with one mission: make building easier.",
    },
  ],
  callout: {
    title: "Why construction?",
    paragraphs: [
      "Because construction keeps the world running — and the technology world has left it behind. Schedules, budgets, field-to-office communication: the industry is full of hardworking companies stuck with software built for someone else.",
      "We don't innovate for innovation's sake. We create tools so crews can focus on what they do best: building.",
    ],
  },
};

export const mission = {
  eyebrow: "Our mission",
  title:
    "We help hardworking companies *excel* by equipping them with *innovative* technology.",
};

export const teamIntro = {
  eyebrow: "The people",
  title: "A team you can *trust.*",
  text: "Knowledgeable in their fields — and willing to go the extra distance to learn your problem from the ground up. Real relationships, real problems, really fixed.",
};

export const reach = {
  home: {
    title: "Rooted in *Hancock, Michigan.* Growing beyond it.",
    text: "Home base is 401 Hancock Street in Michigan's Upper Peninsula, just up the hill from the Portage Lake Lift Bridge. Wherever the work is, we show up.",
    imageAlt:
      "Aerial view of the Portage Lake Lift Bridge joining Houghton and Hancock, Michigan",
  },
};

export const awardsIntro = {
  eyebrow: "Awards & recognitions",
  title: "The hardware on the *shelf.*",
  text: "Two decades of showing up for customers gets noticed now and then.",
};

/** Badge art from the live About page, in its order. */
export const awards = [
  {
    year: "2015",
    name: "Keweenaw Community Sparkplug Award",
    image: "2-1.png",
  },
  {
    year: "2017",
    name: "Michigan Celebrates Small Business — SmartZone Best Small Business",
    image: "4-1.png",
  },
  {
    year: "2017",
    name: "SmartZone — Michigan 50 Companies to Watch",
    image: "3-1.png",
  },
  {
    year: "2021",
    name: "Sandalwood Annual Awards — Supplier of the Year",
    image: "Sandalwoods-Annual-Awards-Supplier-of-the-Year.png",
  },
];

export const aboutCta = {
  title: "Meet the team behind the *software.*",
  text: "Sixty minutes going over your headaches with people who speak contractor, not consultant. You talk, we listen, and you leave with a plain map of what's eating your time.",
};
